import { quickOrderStyles } from "@insite/content-library/Widgets/Basic/QuickOrder";
import { css } from "styled-components";

quickOrderStyles.titleText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
    `,
};

quickOrderStyles.productSelector = {
    container: {
        gap: 30,
        offsetCss: css`
            padding-bottom: 30px;
        `,
    },
    searchGridItem: { width: [12, 12, 5, 5, 6] },
    qtyGridItem: { width: [3, 3, 2, 2, 2] },
    unitOfMeasureGridItem: { width: [9, 9, 2, 2, 2] },
    buttonGridItem: { width: [12, 12, 3, 3, 2] },
    selectButton: {
        css: css`
            width: 100%;
            align-self: flex-end;
        `,
    },
    clearIcon: {
        css: css`
            position: absolute;
            right: 50px;
            top: 55px;
            cursor: pointer;
        `,
    },
};
